import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import adminAuthService from "./adminAuthService";

const initialState = {
  isErrorAdmin: false,
  isSuccessAdmin: false,
  isLoadingAdmin: false,
  message: "",
  homes: null,
  report: null,
  faq: null,
  faqCategory: null,
  history: null,
  userAdmin: null,
  adminIsLoggedInData: null,
  userCount: 0,
  indicator: 0,
  propertyCount: 0,
  viewCounter: 0,
  messageCounter: 0,
};
//register user
export const adminRegister = createAsyncThunk(
  "/akerayu-dh-aa-ad/signup",
  async (user, thunkAPI) => {
    try {
      return await adminAuthService.adminRegisterService(user);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//login user

export const adminLogin = createAsyncThunk(
  "/akerayu-dh-aa-ad/login",
  async (user, thunkAPI) => {
    try {
      return await adminAuthService.adminLoginService(user);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const adminIsLoggedIn = createAsyncThunk(
  "/akerayu-dh-aa-ad/isloggedin",
  async (user, thunkAPI) => {
    try {
      return await adminAuthService.adminIsLoggedInService(user);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const adminGetAllHomes = createAsyncThunk(
  "/akerayu-dh-aa-ad/property/get",
  async (data, thunkAPI) => {
    try {
      return await adminAuthService.adminGetAllHomesService(data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const adminChangeStatusHome = createAsyncThunk(
  "/akerayu-dh-aa-ad/property/update",
  async (data, thunkAPI) => {
    try {
      return await adminAuthService.adminChangeStatusHomeService(data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const adminDismissReport = createAsyncThunk(
  "/akerayu-dh-aa-ad/dismiss/report",
  async (data, thunkAPI) => {
    try {
      return await adminAuthService.adminDismissReportService(data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const adminCountUsers = createAsyncThunk(
  "/akerayu-dh-aa-ad/usercounter",
  async (thunkAPI) => {
    try {
      return await adminAuthService.adminCountUsersService();
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const adminIndicator = createAsyncThunk(
  "/akerayu-dh-aa-ad/indicator",
  async (thunkAPI) => {
    try {
      return await adminAuthService.adminIndicatorService();
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const adminPropertyCounter = createAsyncThunk(
  "/akerayu-dh-aa-ad/propertycounter",
  async (thunkAPI) => {
    try {
      return await adminAuthService.adminPropertyCounterService();
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const adminViewCounter = createAsyncThunk(
  "/akerayu-dh-aa-ad/viewcounter",
  async (thunkAPI) => {
    try {
      return await adminAuthService.adminViewCounterService();
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const adminMessageCounter = createAsyncThunk(
  "/akerayu-dh-aa-ad/messagecounter",
  async (thunkAPI) => {
    try {
      return await adminAuthService.adminMessageCounterService();
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const adminGetReport = createAsyncThunk(
  "/akerayu-dh-aa-ad/report/get",
  async (thunkAPI) => {
    try {
      return await adminAuthService.getReportService();
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const adminGetFaq = createAsyncThunk(
  "/akerayu-dh-aa-ad/faq/get",
  async (thunkAPI) => {
    try {
      return await adminAuthService.getFaqService();
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const adminPostFaq = createAsyncThunk(
  "/akerayu-dh-aa-ad/faq/post",
  async (data, thunkAPI) => {
    try {
      return await adminAuthService.postFaqService(data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const adminUpdateFaq = createAsyncThunk(
  "/akerayu-dh-aa-ad/faq/update",
  async (data, thunkAPI) => {
    try {
      return await adminAuthService.updateFaqService(data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const adminUpdateFaqCategory = createAsyncThunk(
  "/akerayu-dh-aa-ad/faq/category/update",
  async (data, thunkAPI) => {
    try {
      return await adminAuthService.updateFaqCategoryService(data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const adminDeleteFaq = createAsyncThunk(
  "/akerayu-dh-aa-ad/faq/delete",
  async (data, thunkAPI) => {
    try {
      return await adminAuthService.deleteFaqService(data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const adminPostFaqCategory = createAsyncThunk(
  "/akerayu-dh-aa-ad/faq/category/post",
  async (data, thunkAPI) => {
    try {
      return await adminAuthService.postFaqCategoryService(data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const adminGetFaqCategory = createAsyncThunk(
  "/akerayu-dh-aa-ad/faq/category/get",
  async (thunkAPI) => {
    try {
      return await adminAuthService.getFaqCategoryService();
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const adminGetHistory = createAsyncThunk(
  "/akerayu-dh-aa-ad/history/get",
  async (thunkAPI) => {
    try {
      return await adminAuthService.getHistoryService();
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const adminDownloadImage = createAsyncThunk(
  "/akerayu-dh-aa-ad/download/image",
  async (data, thunkAPI) => {
    try {
      return await adminAuthService.postDownloadImageService(data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const adminAuthSlice = createSlice({
  name: "adminAuth",
  initialState,
  reducers: {
    resetAdmin: (state) => {
      state.message = "";
      state.isErrorAdmin = false;
      state.isSuccessAdmin = false;
      state.isLoadingAdmin = false;
    },
    resetAdminTwo: (state) => {
      state.homes = null;
      state.report = null;
      state.faq = null;
      state.faqCategory = null;
      state.history = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(adminGetAllHomes.pending, (state) => {
        state.isLoadingAdmin = true;
      })
      .addCase(adminGetAllHomes.fulfilled, (state, action) => {
        state.isLoadingAdmin = false;
        state.isSuccessAdmin = true;
        state.homes = action.payload;
      })
      .addCase(adminGetAllHomes.rejected, (state, action) => {
        state.isLoadingAdmin = false;
        state.isErrorAdmin = true;
        state.message = action.payload;
      })

      // change home status
      .addCase(adminChangeStatusHome.pending, (state) => {
        state.isLoadingAdmin = true;
      })
      .addCase(adminChangeStatusHome.fulfilled, (state, action) => {
        state.isLoadingAdmin = false;
        state.isSuccessAdmin = true;
        state.message = action.payload.message;
      })
      .addCase(adminChangeStatusHome.rejected, (state, action) => {
        state.isLoadingAdmin = false;
        state.isErrorAdmin = true;
        state.message = action.payload;
      })
      // DISMISS REPORT
      .addCase(adminDismissReport.pending, (state) => {
        state.isLoadingAdmin = true;
      })
      .addCase(adminDismissReport.fulfilled, (state, action) => {
        state.isLoadingAdmin = false;
        state.isSuccessAdmin = true;
        state.message = action.payload.message;
      })
      .addCase(adminDismissReport.rejected, (state, action) => {
        state.isLoadingAdmin = false;
        state.isErrorAdmin = true;
        state.message = action.payload;
      })

      // login admin
      .addCase(adminLogin.pending, (state) => {
        state.isLoadingAdmin = true;
      })
      .addCase(adminLogin.fulfilled, (state, action) => {
        state.isLoadingAdmin = false;
        state.isSuccessAdmin = true;
        state.user = action.payload;
      })
      .addCase(adminLogin.rejected, (state, action) => {
        state.isLoadingAdmin = false;
        state.isErrorAdmin = true;
        state.message = action.payload;
        state.user = null;
      })

      //register admin

      .addCase(adminRegister.pending, (state) => {
        state.isLoadingAdmin = true;
      })
      .addCase(adminRegister.fulfilled, (state, action) => {
        state.isLoadingAdmin = false;
        state.isSuccessAdmin = true;
        state.message = action.payload.message;
      })
      .addCase(adminRegister.rejected, (state, action) => {
        state.isLoadingAdmin = false;
        state.isErrorAdmin = true;
        state.message = action.payload;
        state.user = null;
      })
      .addCase(adminCountUsers.pending, (state) => {
        // state.isLoadingAdmin = true;
      })
      .addCase(adminCountUsers.fulfilled, (state, action) => {
        // state.isLoadingAdmin = false;
        // state.isSuccessAdmin = true;
        state.userCount = action.payload;
      })
      .addCase(adminCountUsers.rejected, (state, action) => {
        // state.isLoadingAdmin = false;
        // state.isErrorAdmin = true;
      })
      .addCase(adminIndicator.pending, (state) => {
        // state.isLoadingAdmin = true;
      })
      .addCase(adminIndicator.fulfilled, (state, action) => {
        // state.isLoadingAdmin = false;
        // state.isSuccessAdmin = true;
        state.indicator = action.payload;
      })
      .addCase(adminIndicator.rejected, (state, action) => {
        // state.isLoadingAdmin = false;
        // state.isErrorAdmin = true;
      })
      .addCase(adminPropertyCounter.pending, (state) => {
        // state.isLoadingAdmin = true;
      })
      .addCase(adminPropertyCounter.fulfilled, (state, action) => {
        // state.isLoadingAdmin = false;
        // state.isSuccessAdmin = true;
        state.propertyCount = action.payload;
      })
      .addCase(adminPropertyCounter.rejected, (state, action) => {
        // state.isLoadingAdmin = false;
        // state.isErrorAdmin = true;
      })

      .addCase(adminViewCounter.pending, (state) => {
        // state.isLoadingAdmin = true;
      })
      .addCase(adminViewCounter.fulfilled, (state, action) => {
        // state.isLoadingAdmin = false;
        // state.isSuccessAdmin = true;
        state.viewCounter = action.payload;
      })
      .addCase(adminViewCounter.rejected, (state, action) => {
        // state.isLoadingAdmin = false;
        // state.isErrorAdmin = true;
      })

      .addCase(adminMessageCounter.pending, (state) => {
        // state.isLoadingAdmin = true;
      })
      .addCase(adminMessageCounter.fulfilled, (state, action) => {
        // state.isLoadingAdmin = false;
        // state.isSuccessAdmin = true;
        state.messageCounter = action.payload;
      })
      .addCase(adminMessageCounter.rejected, (state, action) => {
        // state.isLoadingAdmin = false;
        // state.isErrorAdmin = true;
      })
      //GET REPORT
      .addCase(adminGetReport.pending, (state) => {
        // state.isLoadingAdmin = true;
      })
      .addCase(adminGetReport.fulfilled, (state, action) => {
        // state.isLoadingAdmin = false;
        // state.isSuccessAdmin = true;
        state.report = action.payload;
      })
      .addCase(adminGetReport.rejected, (state, action) => {
        // state.isLoadingAdmin = false;
        // state.isErrorAdmin = true;
      })

      .addCase(adminGetFaqCategory.pending, (state) => {
        state.isLoadingAdmin = true;
      })
      .addCase(adminGetFaqCategory.fulfilled, (state, action) => {
        state.isLoadingAdmin = false;
        state.isSuccessAdmin = true;
        state.faqCategory = action.payload;
      })
      .addCase(adminGetFaqCategory.rejected, (state, action) => {
        state.isLoadingAdmin = false;
        state.isErrorAdmin = true;
        state.message = action.payload;
      })

      .addCase(adminPostFaq.pending, (state) => {
        state.isLoadingAdmin = true;
      })
      .addCase(adminPostFaq.fulfilled, (state, action) => {
        state.isLoadingAdmin = false;
        state.isSuccessAdmin = true;
        state.message = action.payload.message;
      })
      .addCase(adminPostFaq.rejected, (state, action) => {
        state.isLoadingAdmin = false;
        state.isErrorAdmin = true;
        state.message = action.payload;
      })
      .addCase(adminUpdateFaq.pending, (state) => {
        state.isLoadingAdmin = true;
      })
      .addCase(adminUpdateFaq.fulfilled, (state, action) => {
        state.isLoadingAdmin = false;
        state.isSuccessAdmin = true;
        state.message = action.payload.message;
      })
      .addCase(adminUpdateFaq.rejected, (state, action) => {
        state.isLoadingAdmin = false;
        state.isErrorAdmin = true;
        state.message = action.payload;
      })
      .addCase(adminUpdateFaqCategory.pending, (state) => {
        state.isLoadingAdmin = true;
      })
      .addCase(adminUpdateFaqCategory.fulfilled, (state, action) => {
        state.isLoadingAdmin = false;
        state.isSuccessAdmin = true;
        state.message = action.payload.message;
      })
      .addCase(adminUpdateFaqCategory.rejected, (state, action) => {
        state.isLoadingAdmin = false;
        state.isErrorAdmin = true;
        state.message = action.payload;
      })
      .addCase(adminDeleteFaq.pending, (state) => {
        state.isLoadingAdmin = true;
      })
      .addCase(adminDeleteFaq.fulfilled, (state, action) => {
        state.isLoadingAdmin = false;
        state.isSuccessAdmin = true;
        state.message = action.payload.message;
      })
      .addCase(adminDeleteFaq.rejected, (state, action) => {
        state.isLoadingAdmin = false;
        state.isErrorAdmin = true;
        state.message = action.payload;
      })
      .addCase(adminPostFaqCategory.pending, (state) => {
        state.isLoadingAdmin = true;
      })
      .addCase(adminPostFaqCategory.fulfilled, (state, action) => {
        state.isLoadingAdmin = false;
        state.isSuccessAdmin = true;
        state.message = action.payload.message;
      })
      .addCase(adminPostFaqCategory.rejected, (state, action) => {
        state.isLoadingAdmin = false;
        state.isErrorAdmin = true;
        state.message = action.payload;
      })
      //GET Faq
      .addCase(adminGetFaq.pending, (state) => {
        state.isLoadingAdmin = true;
      })
      .addCase(adminGetFaq.fulfilled, (state, action) => {
        state.isLoadingAdmin = false;
        state.isSuccessAdmin = true;
        state.faq = action.payload;
      })
      .addCase(adminGetFaq.rejected, (state, action) => {
        state.isLoadingAdmin = false;
        state.isErrorAdmin = true;
        state.message = action.payload;
      })

      .addCase(adminGetHistory.pending, (state) => {
        state.isLoadingAdmin = true;
      })
      .addCase(adminGetHistory.fulfilled, (state, action) => {
        state.isLoadingAdmin = false;
        state.isSuccessAdmin = true;
        state.history = action.payload;
      })
      .addCase(adminGetHistory.rejected, (state, action) => {
        state.isLoadingAdmin = false;
        state.isErrorAdmin = true;
        state.message = action.payload;
      })
      // isloggedin
      .addCase(adminIsLoggedIn.pending, (state) => {
        // state.isLoading = true;
      })
      .addCase(adminIsLoggedIn.fulfilled, (state, action) => {
        // state.isLoading = false;
        // state.isSuccess = true;
        state.adminIsLoggedInData = action.payload;
      })
      .addCase(adminIsLoggedIn.rejected, (state, action) => {
        // state.isLoading = false;
        // state.isError = true;
        // state.message = action.payload;
        state.adminIsLoggedInData = null;
      });
  },
});

export const { resetAdmin, resetAdminTwo } = adminAuthSlice.actions;

export default adminAuthSlice.reducer;
